import './style.sass';

import React from 'react';
import FullWrapper from '../../cases/reusable-components/layouts-components__common-cases/full-wrapper';

const DefaultNumberList = ({ listCreateNumberProject }) => {
    return (
        <FullWrapper className="default-numberList">
            <div className="default-numberListWrapper">
                <div className="default-numberListTitle">{listCreateNumberProject.title}</div>
                {listCreateNumberProject.list.map(item => (
                    <div key={item.numeric} className="default-numberListItem">
                        <div className="default-numberListItemNumeric">{item.numeric}</div>
                        <div
                            dangerouslySetInnerHTML={{ __html: item.text }}
                            className="default-numberListItemText"
                        />
                    </div>
                ))}
            </div>
        </FullWrapper>
    );
};

export default DefaultNumberList;
